module.exports = __webpack_public_path__ + "img/icon-hot-tip.7932b10b.png";